if (!customElements.get('sld-share')) {
  customElements.define('sld-share', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.input = this.querySelector('[data-share-url]');
      this.status = this.querySelector('[data-share-status]');
      const copyButton = this.querySelector('[data-copy-link]');
      const shareButton = this.querySelector('[data-native-share]');
      if (!this.input || !this.status || !copyButton || !shareButton) return;
      this.initialized = true;
      copyButton.hidden = false;
      copyButton.addEventListener('click', () => this.copyLink());
      if (typeof navigator.share === 'function') {
        shareButton.hidden = false;
        shareButton.addEventListener('click', () => this.shareLink());
      }
    }

    async copyLink() {
      this.status.textContent = '';
      try {
        await navigator.clipboard.writeText(this.input.value);
        this.status.textContent = this.dataset.copied;
      } catch {
        this.input.focus();
        this.input.select();
        this.status.textContent = this.dataset.copyFallback;
      }
    }

    async shareLink() {
      this.status.textContent = '';
      try {
        await navigator.share({
          title: this.dataset.title,
          text: this.dataset.message,
          url: this.input.value
        });
      } catch (error) {
        if (error?.name !== 'AbortError') this.status.textContent = this.dataset.shareFallback;
      }
    }
  });
}
